module.exports = __webpack_public_path__ + "img/shopSectionBackground.3270d048.png";